import AlertAccent from '../../components/AlertAccent';
import * as React from 'react';
import ConfirmAlert from '../../components/ConfirmAlert';
import { useEngineersStore } from './state/use-engineers-store';

const DeleteEngineer = () => {
  const { deleteModal, setDeleteModal, removeEngineer, resetDeleteData, deleteEngineerName } = useEngineersStore();

  return (
    <ConfirmAlert showAlert={deleteModal} setShowAlert={setDeleteModal} closeCb={resetDeleteData} delCb={removeEngineer} title="Удаление инженера">
      <AlertAccent text={`Вы действительно хотите удалить инженера ${deleteEngineerName ?? ''}?`} showAlert={true}>
        <p>Внимание, все данные будут безвозвратно удалены</p>
      </AlertAccent>
    </ConfirmAlert>
  );
};

export default DeleteEngineer;
